export default __webpack_public_path__ + "static/media/advance_avatar.f7d88c5e.jpg";